<template>
    <a-date-picker :inputReadOnly="true" v-bind="$attrs" v-model="dateValue" v-on="$listeners">
        <slot name="renderExtraFooter" slot="renderExtraFooter"></slot>
    </a-date-picker>
</template>

<script>
    import moment from "moment";
    import func from "../utils/func";

    export default {
        name: "DatePicker",
        computed: {
            dateValue: {
                get() {
                    if (!this.$attrs.value) return;
                    return moment(func.tsFormat(this.$attrs.value, this.$attrs.format), this.$attrs.format);
                },
                set(value) {
                    this.$emit("input", value ? parseInt(value.format("X")) : 0);
                }
            }
        },
        mounted() {

        }
    }
</script>
